import React, { useState, useEffect, useCallback } from "react";
import InputDoctorAndPatient from "../../otc_transaction/component/inputDoctorAndPatient";
import InputDoctorTreatmentTransaction from "../component/inputDoctorTreatmentTransaction";
import { useNavigate } from "react-router-dom";
import { Constant } from "../../../../helper/constant";
import { getIndonesianISOString } from "../../../../helper/formatDate";
import PaymentMethodOtcTransaction from "../../otc_transaction/component/paymentMethodOtcTransaction";
import TotalOtcPayment from "../../otc_transaction/component/totalOtcPayment";

const DoctorTreatmentTransaction = () => {
  // =====================
  // Constant Definition
  // =====================
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [doctorData, setDoctorData] = useState({
    doctor_id: "",
    doctor_name: "",
  });
  const [patientData, setPatientData] = useState({
    patient_id: "",
    patient_name: "",
  });
  const [doctorTreatmentTransactionData, setDoctorTreatmentTransactionData] =
    useState([
      {
        treatment_id: "",
        treatment_name: "",
        treatment_total_price: 0,
      },
    ]);

  const [totalTransaction, setTotalTransaction] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [buyerCashTransaction, setBuyerCashTransaction] = useState(0);
  const listPayment = [
    "CASH",
    "TRANSFER",
    "DEBIT",
    "QRIS",
    "KARTU KREDIT",
    "REKANAN",
  ];
  const listRemainingPaymentOption = [
    "TIDAK ADA",
    "CASH",
    "TRANSFER",
    "DEBIT",
    "QRIS",
    "KARTU KREDIT",
  ];
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("CASH");
  const [remainingPaymentOption, setSelectedRemainingPaymentOption] =
    useState("TIDAK ADA");
  const [bankData, setBankData] = useState(null);
  const [selectedBankOption, setSelectedBankOption] = useState(null);
  const [partnerData, setParnerData] = useState({
    partner_id: "",
    partner_name: "",
  });
  const [insuranceCovered, setInsuranceCovered] = useState(0);

  // =====================
  // Method Definition
  // =====================

  const onConfirmCliked = () => {
    confirmTransaction();
  };

  // =====================
  // Network Request Definition
  // =====================
  const getBankData = useCallback(async () => {
    try {
      setIsLoading(true);

      let url = Constant.BASE_API_URL + "/bank/bank-data";
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
      });
      if (!response.ok) {
        alert("Gagal Menerima Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
      const json = await response.json();
      const data = json.data;
      if (!data.banks) {
        setBankData(null);
      } else {
        setBankData(data.banks);
        setSelectedBankOption(data.banks[0]);
      }
    } catch (error) {
      setBankData(null);
    } finally {
      setIsLoading(false);
    }
  }, [navigate]);

  const confirmTransaction = async () => {
    try {
      setIsLoading(true);
      const staffData = localStorage.getItem("user_data");
      const parsedStaffData = JSON.parse(staffData);

      const treatmentData = doctorTreatmentTransactionData.map((treatment) => {
        return {
          medical_transaction_id: treatment.treatment_id,
          medical_transaction_name: treatment.treatment_name,
          medical_transaction_service_fee: Number(
            treatment.treatment_total_price
          ),
        };
      });

      let url = Constant.BASE_API_URL + "/tindakan-medis-transaksi";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify({
          medical_transaction_date: getIndonesianISOString(),
          staff_id: parsedStaffData.staff_id,
          staff_name: parsedStaffData.staff_name,
          staff_shift: Number(localStorage.getItem("staff_shift")),
          doctor_id: doctorData.doctor_id,
          doctor_name: doctorData.doctor_name,
          patient_id: patientData.patient_id,
          patient_name: patientData.patient_name,
          medical_transaction_data: treatmentData,
          partner_id: partnerData.partner_id,
          partner_name: partnerData.partner_name,
          payment_bank_id:
            selectedPaymentOption !== "TRANSFER"
              ? ""
              : selectedBankOption.bank_id,
          payment_bank_name:
            selectedPaymentOption !== "TRANSFER"
              ? ""
              : selectedBankOption.bank_name,
          payment_method:
            selectedPaymentOption === "REKANAN"
              ? remainingPaymentOption
              : selectedPaymentOption,
          cash_transaction: buyerCashTransaction,
          total_transaction: totalTransaction,
          total_payment: totalPayment,
          total_insurance_covered: insuranceCovered,
        }),
      });
      if (!response.ok) {
        alert("Gagal Membuat Transaksi Baru");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      } else {
        setIsLoading(false);
        navigate("/klinik-penjualan-perhari");
      }
    } catch (error) {
      alert("Gagal Membuat Transaksi Baru");
    } finally {
      setIsLoading(false);
    }
  };

  // =====================
  // Hooks Definition
  // =====================

  useEffect(() => {
    const roundToNearest100 = (value) => {
      return Math.ceil(value / 100) * 100;
    };

    var totalAmount = 0;
    var totalPayment = 0;

    doctorTreatmentTransactionData.forEach((treatmentData) => {
      totalAmount += Number(treatmentData.treatment_total_price);
    });
    const roundedTotalAmount = roundToNearest100(totalAmount);
    totalPayment = roundedTotalAmount;
    setTotalTransaction(roundedTotalAmount);

    if (
      selectedPaymentOption === "REKANAN" &&
      roundedTotalAmount - insuranceCovered >= 0 &&
      partnerData.partner_id !== ""
    ) {
      totalPayment -= insuranceCovered;
    }
    setTotalPayment(totalPayment);
  }, [
    doctorTreatmentTransactionData,
    selectedPaymentOption,
    insuranceCovered,
    partnerData,
  ]);

  useEffect(() => {
    getBankData();
  }, [getBankData]);

  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <h1>Kasir Dokter</h1>
      <InputDoctorAndPatient
        doctorData={doctorData}
        setDoctorData={setDoctorData}
        patientData={patientData}
        setPatientData={setPatientData}
      />
      <InputDoctorTreatmentTransaction
        doctorTreatmentTransactionData={doctorTreatmentTransactionData}
        setDoctorTreatmentTransactionData={setDoctorTreatmentTransactionData}
      />
      <PaymentMethodOtcTransaction
        listPayment={listPayment}
        selectedPaymentOption={selectedPaymentOption}
        setSelectedPaymentOption={setSelectedPaymentOption}
        listBank={bankData}
        selectedBankOption={selectedBankOption}
        setSelectedBankOption={setSelectedBankOption}
        buyerCash={buyerCashTransaction}
        setBuyerCash={setBuyerCashTransaction}
        totalTransaction={totalTransaction}
        setPartnerData={setParnerData}
        partnerData={partnerData}
        insuranceCovered={insuranceCovered}
        setInsuranceCovered={setInsuranceCovered}
        listRemainingPaymentOption={listRemainingPaymentOption}
        remainingPaymentOption={remainingPaymentOption}
        setSelectedRemainingPaymentOption={setSelectedRemainingPaymentOption}
      />
      <TotalOtcPayment
        totalAmount={totalPayment}
        onConfirmCliked={onConfirmCliked}
      />
    </div>
  );
};

export default DoctorTreatmentTransaction;
